/** People see effort tiers, not provider model names. */
const TIERS: Record<string, string> = { 'claude-haiku-5-5': 'Low', 'claude-sonnet-5-5': 'Medium', 'claude-opus-5-5': 'High', 'claude-fable-5-1': 'Extra High' };
export const tierName = (model?: string | null) => (model ? TIERS[model] ?? 'Lumnos' : 'Lumnos');
